import { render, staticRenderFns } from "./NavMenuSectionTitle.vue?vue&type=template&id=5ac1e7d6&scoped=true"
import script from "./NavMenuSectionTitle.vue?vue&type=script&lang=js"
export * from "./NavMenuSectionTitle.vue?vue&type=script&lang=js"
import style0 from "./NavMenuSectionTitle.vue?vue&type=style&index=0&id=5ac1e7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1e7d6",
  null
  
)

export default component.exports